import React from "react";

function Footer() {
  return (
    <footer className="page-footer font-small">
      <div className="footer-copyright text-center py-3">
        <span className="text-muted">Clicky Game! | Copyright &copy; Tina Li 2019 | 
          <a href="https://github.com/tinali91/mongoose-scraper" target="blank">GitHub Repository</a> | 
          <a href="https://tinali91.github.io/updatedPortfolio/" target="blank">Portfolio</a>
        </span>
      </div>
    </footer>

  )
}

export default Footer;